<template>
  <div :style="{width: vertical ? ticks ? '36px' : '18px' : width}" :class="[baseCss, 'inline-block', 'text-xs', setTextColor('labelColor', 'labelColorLightness'), disabled ? ['disabled', 'pointer-events-none'] : null, vertical ? `${baseCss}-vertical` : null, 'select-none']" :data-slider="uuid">
    <label :for="`slider-${uuid}`">
      <table-layout :is="vertical ? 'div' : 'table-layout'" equal-cells y-align="middle">
        <row>
          <cell v-if="min !== null && labels" v-html="vertical ? max : min" :class="[`${baseCss}-label`, vertical ? 'py-1' : 'px-1']" :x-align="vertical ? 'center' : 'right'" />
          <cell :class="[vertical ? 'py-1' : 'px-1', ]" x-align="center">
            <table-layout :is="vertical ? 'table-layout' : 'div'" equal-cells>
              <row>
                <cell>
                  <input :id="`slider-${uuid}`" :style="{width: vertical ? '18px' : null, height: vertical ? height : null}" :disabled="disabled" @mouseup="onMouseUp" @input="onInput($event)" :orient="vertical ? 'vertical' : null" type="range" :min="min" :max="max" :step="step" :value="value" :class="['block', 'w-full']" />
                </cell>
                <cell v-if="ticks && step && vertical && min !== null && max !== null">
                  <slider-ticks :tick-fractions="tickFractions" :uuid="uuid" :step="step" :vertical="vertical" :max="max" />
                </cell>
              </row>
            </table-layout>
          </cell>
          <cell v-if="max !== null && labels" width="10%" v-html="vertical ? min : max" :class="[`${baseCss}-label`, vertical ? 'py-1' : 'px-1']" :x-align="vertical ? 'center' : 'left'" />
        </row>
        <row v-if="ticks && step && !vertical && min !== null && max !== null">
          <cell v-if="min !== null && labels" :class="['px-1', 'invisible', vertical ? 'py-1' : '', `${baseCss}-label`]">&nbsp;</cell>
          <cell :class="['px-1', vertical ? 'py-1' : '']" x-align="center">
            <slider-ticks :class="!labels ? 'mt-2' : null" :tick-fractions="tickFractions" :uuid="uuid" :step="step" :vertical="vertical" :max="max" />
          </cell>
          <cell v-if="max !== null && labels" :class="['px-1', 'invisible', vertical ? 'py-1' : '', `${baseCss}-label`]">&nbsp;</cell>
        </row>
      </table-layout>
    </label>
    <div hidden :class="[setBgColor('color', 'colorLightness'), `${baseCss}-slider-colors`, 'hidden']" />
    <reactive-style>
    .bcq-slider[data-slider="{{ uuid }}"] input[type="range"]::-webkit-slider-runnable-track
    {
      background: {{ sliderBgColor }};
    }

    .bcq-slider[data-slider="{{ uuid }}"] input[type="range"]::-moz-range-track
    {
      background: {{ sliderBgColor }};
    }

    .bcq-slider[data-slider="{{ uuid }}"] input[type="range"]::-moz-range-thumb
    {
      background: {{ sliderBgColor }};
    }

    .bcq-slider[data-slider="{{ uuid }}"] input[type="range"]::-webkit-slider-thumb
    {
      background: {{ sliderBgColor }};
    }

    .bcq-slider[data-slider="{{ uuid }}"]:not(.bcq-slider-vertical) .bcq-slider-ticks,
    .bcq-slider[data-slider="{{ uuid }}"] .bcq-slider-ticks .bcq-table-layout-cell
    {
      border-color: {{ sliderLabelColor }};
    }
    </reactive-style>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import SliderTicks from './slider-ticks'

export default {
  name: 'Slider',
  components: {
    SliderTicks
  },
  mixins: [
    methods
  ],
  data () {
    return {
      uuid: this.$uuidv4(),
      sliderBgColor: null,
      sliderLabelColor: null,
      baseCss: this.componentBaseCss('slider', [])
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    value: {
      type: Number,
      default: 0
    },
    step: {
      type: Number
    },
    vertical: {
      type: Boolean
    },
    ticks: {
      type: Boolean
    },
    tickFractions: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean
    },
    color: {
      type: String,
      default: 'gray'
    },
    colorLightness: {
      type: Number,
      default: 500
    },
    labelColor: {
      type: String,
      default: 'black'
    },
    labelColorLightness: {
      type: Number,
      default: null
    },
    width: {
      type: String
    },
    height: {
      type: String,
      default: '128px'
    },
    labels: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    color () {
      this.$nextTick(() => {
        this.getSliderColors()
      })
    },
    colorLightness () {
      this.$nextTick(() => {
        this.getSliderColors()
      })
    },
    labelColor () {
      this.$nextTick(() => {
        this.getSliderColors()
      })
    },
    labelColorLightness () {
      this.$nextTick(() => {
        this.getSliderColors()
      })
    }
  },
  mounted () {
    this.getSliderColors()
  },
  methods: {
    onInput ($event) {
      this.$emit('input', parseInt($event.target.value, 10))
    },
    getSliderColors () {
      const element = this.$el.querySelector('.bcq-slider-slider-colors')
      const sliderBgColor = getComputedStyle(element, null).getPropertyValue('background-color')
      const sliderLabelColor = getComputedStyle(element, null).getPropertyValue('color')
      this.sliderBgColor = sliderBgColor
      this.sliderLabelColor = sliderLabelColor
    },
    onMouseUp () {
      this.$el.querySelector('input[type="range"]').blur()
    }
  }
}
</script>
<style>
.bcq-slider.bcq-slider-vertical input[type="range"]
{
  -webkit-appearance: slider-vertical;
}

.bcq-slider input[type="range"]
{
  -webkit-appearance: none;
  background: none;
}

.bcq-slider input[type="range"]:focus
{
  outline: none;
}

.bcq-slider input[type="range"]::-webkit-slider-runnable-track
{
  height: 5px;
}

.bcq-slider input[type="range"]::-moz-range-track
{
  height: 5px;
}

.bcq-slider input[type="range"]::-webkit-slider-thumb
{
  -webkit-appearance: none;
  height: 15px;
  width: 15px;
  margin-top: -5px;
  border-radius: 100%;
}

.bcq-slider input[type="range"]::-moz-range-thumb
{
  height: 15px;
  width: 15px;
  margin-top: -5px;
  border-radius: 100%;
}

.bcq-slider.bcq-slider-vertical input[type="range"]::-webkit-slider-runnable-track
{
  border-radius: 15px;
}

.bcq-slider.bcq-slider-vertical input[type="range"]::-moz-range-track
{
  border-radius: 15px;
}

.bcq-slider:not(.bcq-slider-vertical) .bcq-slider-label
{
  width: 10% !important;
}

.bcq-slider:not(.bcq-slider-vertical) .bcq-slider-ticks .bcq-table-layout-cell
{
  height: 10px;
  border: solid 1px;
}

.bcq-slider:not(.bcq-slider-vertical) .bcq-slider-ticks .bcq-slider-ticks-fractions .bcq-table-layout-cell
{
  height: 6px;
}

.bcq-slider:not(.bcq-slider-vertical) .bcq-slider-ticks .bcq-slider-ticks-fractions .bcq-table-layout-cell:first-of-type
{
  border-left: 0;
}

.bcq-slider:not(.bcq-slider-vertical) .bcq-slider-ticks .bcq-slider-ticks-fractions .bcq-table-layout-cell:last-of-type
{
  border-right: 0;
}

.bcq-slider .bcq-slider-ticks
{
  opacity: .25;
  padding: 0 7px;
}

.bcq-slider:not(.bcq-slider-vertical) .bcq-slider-ticks
{
  border-bottom: solid 1px;
}

.bcq-slider:not(.bcq-slider-vertical) .bcq-slider-ticks .bcq-table-layout-cell
{
  border-top: 0;
  border-bottom: 0;
}

.bcq-slider.bcq-slider-vertical .bcq-slider-ticks-full
{
  width: 10px;
}

.bcq-slider.bcq-slider-vertical .bcq-slider-ticks-full > div > .bcq-table-layout-cell
{
  border-top: solid 1px;
  border-bottom: solid 1px;
}

.bcq-slider.bcq-slider-vertical .bcq-slider-ticks-full
{
  height: calc(100% - 14px);
  margin-top: 7px;
}

.bcq-slider.bcq-slider-vertical .bcq-slider-ticks-fractions
{
  width: 6px;
}

.bcq-slider.bcq-slider-vertical .bcq-slider-ticks-fractions .bcq-table-layout-row:first-of-type .bcq-table-layout-cell:first-of-type
{
  border-bottom: solid 1px;
}

.bcq-slider.bcq-slider-vertical .bcq-slider-ticks-fractions .bcq-table-layout-row:last-of-type .bcq-table-layout-cell
{
  border-top: solid 1px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/slider/slider.vue